module.exports = __webpack_public_path__ + "static/nerdo-0bc2b2d5ff9177f649a9f47acab97b13.png";